import React, { useEffect, useState } from 'react'
import { newsApi } from '../../services/newsApi'
import logo from "./../../assets/images/bnb.png"
import moment from 'moment'

export const NewsList = () => {
    const [newsList, setNewsList] = useState([])
    // @ts-ignore
    const { data } = newsApi.useGetNewsQuery()
    useEffect(() => {
        setNewsList(data?.value)
    }, [data])
   
    return (
        <section className="news" id="news">
            <div className="container">
                <h3 className='news__title'>Last News about Crypto</h3>
                <div className="news__inner">
                    {/* @ts-ignore */}
                    {newsList?.map((news) => <News key={news.datePublished} text={news.description} author={news.provider[0]?.name} title={news.name} link={news.url} data={news.datePublished} image={news.image?.thumbnail?.contentUrl} avatar={news.provider[0]?.image?.thumbnail?.contentUrl} />)}
                </div>
            </div>
        </section >
    )
}
type NewsPropsType = {
    author: string
    image: string
    title: string
    avatar: string
    data: string
    link: string
    text: string
}
const News: React.FC<NewsPropsType> = ({ author, image, text, title, avatar, data, link }) => {
    return (

        <article className="news__post post">
            <div className="post__info">
                <a className="post__img-wrapper" href={link} target="_blank" rel="noreferrer">
                    <img
                        className="post__img"
                        src={image || "https://images.unsplash.com/photo-1519162584292-56dfc9eb5db4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=775&q=80"}
                        alt="newsImage"
                    />
                </a>
                <a className="post__title" href={link} target="_blank" rel="noreferrer">
                    {title}
                </a>
                <p className="post__description">{text}</p>
                <div className="post__box">
                    <div className="post__author-wrapper">
                        <img
                            className="post__author-img"
                            src={avatar || logo}
                            alt='logo'
                        />
                        <p className="post__author"> {author}</p>
                    </div>
                    <div className="post__date">{moment(data).fromNow()}</div>
                </div>
            </div>
        </article>

    )
}

export default News
